const REFUND_CHANNEL_LABEL_KEYS = {
    bank: 'suppliers:transferForm.refundChannels.bank',
    credit_card: 'suppliers:transferForm.refundChannels.creditCard',
    wallet: 'suppliers:transferForm.refundChannels.wallet'
}

const REFUND_WALLET_PROVIDER_LABEL_KEYS = {
    xendit: 'suppliers:transferForm.refundWalletProviders.xendit',
    xendit_gbprime: 'suppliers:transferForm.refundWalletProviders.xenditGbprime',
    true_money: 'suppliers:transferForm.refundWalletProviders.trueMoney'
}

const refundChannelLabel = (i18n, record) => {
    const channelKey = REFUND_CHANNEL_LABEL_KEYS[record.refund_channel]
    if (!channelKey) { return null }

    const providerKey = REFUND_WALLET_PROVIDER_LABEL_KEYS[record.refund_wallet_provider]
    const channel = i18n.t(channelKey)

    return providerKey ? `${channel} (${i18n.t(providerKey)})` : channel
}

export { refundChannelLabel }
